module.exports = __webpack_public_path__ + "img/industry_insights.9726b405.svg";